export default function Container({children}: {children: any}) {
    return (
        <div className="bg-white w-full border rounded-lg px-6 py-4 shadow shadow-gray-200 relative">
            {children}
        </div>
    )
}